"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaVersionKey = void 0;
exports.schemaVersionKey = "__schemaVersion";
//# sourceMappingURL=schema.js.map